var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 107,
    viewBox: "0 0 110 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boy",
    transform: "translate(21 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(6.726 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M28.835,55.41a27.309,27.309,0,0,0,0-54.616,27.309,27.309,0,0,0,0,54.616Z",
    transform: "translate(-1.695 3.248)",
    fill: "#fff",
    stroke: "#231f20",
    strokeWidth: 0.09,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M13.437,3.421C2.93,8.867,1.042,21.312,1.931,32.017c5.685-.4,14.243-4.637,18.626-8.21a14.726,14.726,0,0,1-6.882,6.744c8.533-2.072,13.991-6.363,20.191-12.532a24.173,24.173,0,0,1-5.806,10.348c4.509.031,8.154-4.825,11.158-7.778a23.768,23.768,0,0,1-3.585,7.065c3.539-.672,6.543-3.329,8.593-6.332,2.181,4.83,7.584,6.078,11.784,7.808L56,28.917C55.217,17.276,52.789,7.478,40.944,2.5A33.374,33.374,0,0,0,28.125,0,32.18,32.18,0,0,0,13.437,3.421Z",
    transform: "translate(-1.737 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M54.711,49.468a2.833,2.833,0,0,0,1.978-.84,2.8,2.8,0,0,0,0-3.988,2.75,2.75,0,0,0-3.956,0,2.8,2.8,0,0,0,0,3.988A2.833,2.833,0,0,0,54.711,49.468Zm19.989,0a2.833,2.833,0,0,0,1.978-.84,2.8,2.8,0,0,0,0-3.988,2.75,2.75,0,0,0-3.956,0,2.8,2.8,0,0,0,0,3.988A3.033,3.033,0,0,0,74.7,49.468Z",
    transform: "translate(-37.84 -12.775)",
    fill: "#b07f4a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M121.14,178.932c-.937-5.458-3.123-17.108-3.644-18.682-2.394-7.347-8.537-10.915-15.1-13.644-.833-.315-1.666-.735-2.5-1.05-5.726-2.2-11.452-4.513-17.178-6.717a17.942,17.942,0,0,1-33.106,0c-5.726,2.2-11.452,4.513-17.178,6.717a25.317,25.317,0,0,0-2.5,1.05c-6.559,2.729-12.6,6.3-15.1,13.644-.521,1.469-2.6,13.224-3.644,18.682a2.191,2.191,0,0,0,1.145,2.414,2.086,2.086,0,0,0,1.145.315H118.746a2.086,2.086,0,0,0,1.145-.315A2.412,2.412,0,0,0,121.14,178.932Z",
    transform: "translate(-32.156 -38.661)",
    fill: "#263a4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.7859e1d71e3b49a4e3a354ff4750e383.svg";
export { ForwardRef as ReactComponent };